// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"6019": "f8fe3908","6557": "fe427090","8357": "dd422574","9740": "ad6e017e",}[chunkId] + ".css"
}